import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import RequiredSelect from '../../../../common/form/elements/required-select';
import BsCheckbox from '../../../../common/form/elements/bs-checkbox';
import BsRadio from '../../../../common/form/elements/bs-radio';
import ImageUpload from '../../../../common/form/elements/image-upload';
import RequiredInput from '../../../../common/form/elements/required-input';
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import MultiSelect from '../../../../common/form/multi-select';
import DatePicker from '../../../../common/form/datepicker';
import ArrowButton from '../../../../common/button-arrow';
import SectionTitle from '../../../../common/section-title/index';
import ColorPicker from '../../../../common/form/elements/color-picker';
import { saveArticle, updateArticle } from '../../../../../actions/news';
import GroupMultiSelect from '../../../../common/groups/group-multi-select';
import TextInput from '../../../../common/form/elements/text-input';

class EditArticleForm extends Component {
  // eslint-disable-next-line consistent-return, class-methods-use-this
  generatePermissions(permissions) {
    if (permissions.length) {
      return (
        permissions.map((permission, index) => (
          <FormGroup
            className="permission-block"
            key={`perm-group-${index}`}
          >
            <b>
              {permission.name}
            </b>
            {
              permission.children
                .filter(child => !['ABM', 'RBM', 'Ordering Store', 'Non Ordering Store', 'Incentive eligible Store'].includes(child.name))
                .map((child, permissionIndex) => (
                  <Control.checkbox
                    component={BsCheckbox}
                    key={`perm-${permissionIndex}`}
                    model={`.permission_ids[${child.id}].checked`}
                  >
                    {child.name}
                  </Control.checkbox>
              ))
            }
          </FormGroup>
        ))
      );
    }
  }

  onSubmit(payLoad) {
    const { dispatch, article } = this.props;

    if (article.id) {
      dispatch(actions.submitFields('deep.admin_news.article', updateArticle(article.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_news.article', saveArticle(payLoad)));
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(actions.resetValidity('deep.admin_news.article'));
  }

  render() {
    const {
      article, articleForm, abmCodes, ...props
    } = this.props;
    let image;
    let icon;
    let displayFromDate = '';
    let displayToDate = '';
    let linkedArticles = [];
    let titleTextColour;
    let { permissions } = props;
    let groupIds = [];
    let selectedAbmCodes = [];

    const { attributes } = article;

    if (attributes) {
      image = attributes.link ? attributes.link.image : undefined;
      icon = attributes.link ? attributes.link.icon : undefined;
      displayFromDate = attributes['display-from-date'];
      displayToDate = attributes['display-to-date'];
      linkedArticles = attributes['linked-articles'];
      titleTextColour = attributes['title-text-colour'];
      // eslint-disable-next-line prefer-destructuring
      permissions = attributes.permissions;
    }

    if (articleForm && articleForm.group_ids) {
      groupIds = articleForm.group_ids;
    }

    if (articleForm && articleForm.abm_codes) {
      selectedAbmCodes = articleForm.abm_codes;
    }

    const sizeLimit = 1024 * 1024;

    return (
      <Form
        model="deep.admin_news.article"
        onSubmit={this.onSubmit.bind(this)}
        validators={{
          '': {
            featured: vals => vals.featured,
            display_location: vals => vals.display_location
          }
        }}
      >
        <Row className="float-end">
          <Col lg={12}>
            <ArrowButton
              arrow={false}
              className="float-end"
              disabled={!props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId='title'
              label="Title"
              model='.title'
              placeholder="Title"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="titleTextColour">
              <ColorPicker
                model="deep.admin_news.article.title_text_colour"
                textModel="deep.admin_news.article.title_text_colour"
                name="deep.admin_news.article.title_text_colour"
                textName="deep.admin_news.article.title_text_colour"
                label="Title text colour*"
                defaultColor={titleTextColour || 'White'}
                defaultTextColor={titleTextColour}
                backgroundColorPicker={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect
              controlId="newsCategory"
              label="Category"
              labelAttr='attributes.name'
              model=".news_category_id"
              valueAttr='id'
              values={props.categoryList}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".image"
              required
              sizeLimit={sizeLimit}
              source={image}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect
              controlId="brandCategory"
              label="Status"
              model=".status"
              values={props.statusList}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredDatePicker
              controlId="displayFromDate"
              label="Display from date"
              model="deep.admin_news.article.display_from_date"
              placeholder="Select a date..."
              timeFormat="HH:mm"
              value={displayFromDate}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <DatePicker
              label="Display to date"
              model="deep.admin_news.article.display_to_date"
              placeholder="Select a date..."
              timeFormat="HH:mm"
              value={displayToDate}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup
              className="display-location-block"
            >
              <div>
                Display location*
              </div>
              <Control.radio
                model=".display_location"
                value="website"
                inline
                component={BsRadio}
              >
                Website only
              </Control.radio>
              <Control.radio
                model=".display_location"
                value="app"
                inline
                component={BsRadio}
              >
                App only
              </Control.radio>
              <Control.radio
                model=".display_location"
                value="both"
                inline
                component={BsRadio}
              >
                Both
              </Control.radio>
              <Errors
                className="errors"
                messages={{display_location: 'You must set display location.'}}
                model="deep.admin_news.article"
                show={{touched: true}}
              />
            </FormGroup>
          </Col>
        </Row>
        { (articleForm.display_location === 'app' || articleForm.display_location === 'both') && (
          <Row>
            <Col lg={12}>
              <ImageUpload
                model=".icon"
                label="Upload an icon"
                required
                sizeLimit={1024 * 1024}
                source={icon}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
        ) }
        <Row>
          <Col lg={12}>
            <FormGroup>
              <FormLabel>
                Featured article
              </FormLabel>
              <br/>
              <Control.radio
                model=".featured"
                value="true"
                inline
                component={BsRadio}
              >
                Yes
              </Control.radio>
              <Control.radio
                model=".featured"
                value="false"
                inline
                component={BsRadio}
              >
                No
              </Control.radio>
              <Errors
                className="errors"
                messages={{featured: 'You must set featured state.'}}
                model="deep.admin_news.article"
                show={{touched: true}}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <SectionTitle>
              Article permissions
            </SectionTitle>
            <GroupMultiSelect
              model={'deep.admin_news.article.group_ids'}
              required={false}
              value={groupIds}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <MultiSelect
              controlId="articleAbmCodes"
              data={abmCodes || []}
              label="Eligible abm regions"
              model='deep.admin_news.article.abm_codes'
              value={selectedAbmCodes}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {this.generatePermissions(permissions)}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup>
              <b>Mini Chain</b>
              <Control.checkbox
                component={BsCheckbox}
                key="mc-only-outlets"
                model="deep.admin_news.article.mc_only_outlets"
              >
                MC Only Outlets
              </Control.checkbox>
              <Control.checkbox
                component={BsCheckbox}
                key="non-mc-only-outlets"
                model="deep.admin_news.article.non_mc_only_outlets"
              >
                Non-MC Only Outlets
              </Control.checkbox>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <MultiSelect
              controlId="linkedArticles"
              data={props.linkArticles}
              label="Linked articles"
              labelAttr="title"
              model="deep.admin_news.article.linked_article_ids"
              value={linkedArticles}
              valueAttr="id"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId='videoLink'
              label="Video Link"
              model='.video_link'
              placeholder="Video Link"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId='gameLink'
              label="Game Link"
              model='.game_link'
              placeholder="Game Link"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId='cataboomId'
              label='Cataboom Id'
              model='.cataboom_id'
              placeholder='Cataboom Id'
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId="externalUrl"
              label="External URL"
              model=".external_url"
              placeholder="External URL"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              arrow={false}
              className="float-end"
              disabled={!props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_news.article.$form.valid,
  articleForm: state.deep.admin_news.article
});

export default connect(mapStateToProps)(EditArticleForm);
